import { render, staticRenderFns } from "./ChangeAssetsLocation.vue?vue&type=template&id=ba32de08"
import script from "./ChangeAssetsLocation.vue?vue&type=script&lang=js"
export * from "./ChangeAssetsLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports